import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ERROR_TYPE } from "../pages/error-page/error-page.component";
import { ApiService } from "./api/api.service";

export interface IHandleLinkQuery {
  token: string;
  pageid?: string;
  modalid?: string;
  userid?: string;
  deadline?: string;
  patientid?: string;
  serviceid?: string;
  crypt?: string;
  phone?: string;
  birth?: string;
  sex?: string;
  lang?: string;
  line?: string;
  postal?: string;
  city?: string;
  country?: string;
  internalId?: string;
}

export interface IRedirectionResult {
  headers: {
    domain: string;
    source?: string;
    "x-access-token"?: string;
    "redirect-pageid"?: string;
    "redirect-modalid"?: string;
    "redirect-patientid"?: string;
    "redirect-serviceid"?: string;
    "redirect-organization"?: string;
    "error-type"?: ERROR_TYPE;
  };
  data?: {
    name: string;
    value: string | number;
  }[];
}

@Injectable({
  providedIn: "root",
})
export class HandleLinkService {
  constructor(private api: ApiService) {}

  /**
   * Handles link redirection
   * @param params Query parameters (IHandleLinkQuery)
   * @returns Redirection information
   */
  public handleLink(params: IHandleLinkQuery): Observable<IRedirectionResult> {
    const queryParams: Record<string, string> = {
      shortid: params.token ?? undefined,
      pageid: params.pageid ?? undefined,
      modalid: params.modalid ?? undefined,
      userid: params.userid ?? undefined,
      deadline: params.deadline ?? undefined,
      patientid: params.patientid ?? undefined,
      serviceid: params.serviceid ?? undefined,
      crypt: params.crypt ?? undefined,
      phone: params.phone ?? undefined,
      birth: params.birth ?? undefined,
      sex: params.sex ?? undefined,
      lang: params.lang ?? undefined,
      line: params.line ?? undefined,
      postal: params.postal ?? undefined,
      city: params.city ?? undefined,
      country: params.country ?? undefined,
      internalId: params.internalId ?? undefined,
    };

    return this.api.get("handle-link", queryParams) as Observable<IRedirectionResult>;
  }
}
